export const RESET = 'DOCUMENTTYPE_UPDATE_RESET'
export const SET_ERROR = 'DOCUMENTTYPE_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'DOCUMENTTYPE_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'DOCUMENTTYPE_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'DOCUMENTTYPE_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'DOCUMENTTYPE_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'DOCUMENTTYPE_UPDATE_UPDATE_RETRIEVED'
